import { ReactNode, useCallback } from 'react';

import { useLocation } from 'react-router-dom';

import { useMediaQuery } from '../../vendor/ui';

import { HeaderLink, HeaderTitle, Layout } from '../../components/layout';
import { Logo } from '../../components/logo';
import { DEVICE_SIZES } from '../../constants/common';

import { Wrapper } from './styled';

interface IProps {
  children?: ReactNode;
}

type TMenuItemProps = {
  path?: string;
  disabled?: boolean;
  isUrl: boolean;
  onClick: () => void;
};

export const LayoutAuth = ({ children }: IProps) => {
  const location = useLocation();
  const isMobile = useMediaQuery(`(max-width: ${DEVICE_SIZES.tablet})`);

  const menuItemRender = useCallback(
    (menuItemProps: TMenuItemProps, defaultDom: React.ReactNode) => {
      return (
        <HeaderLink to={menuItemProps.path!} $disabled={menuItemProps.disabled}>
          {defaultDom}
        </HeaderLink>
      );
    },
    [],
  );

  const headerTitleRender = (logo: ReactNode, title: ReactNode) => {
    return <HeaderTitle title={title} logo={<Logo isHeader />} />;
  };

  return (
    <Wrapper>
      <Layout
        logo={isMobile ? <Logo /> : false}
        title=''
        layout='mix'
        contentWidth='Fluid'
        siderMenuType='group'
        location={location}
        menuItemRender={menuItemRender}
        headerTitleRender={headerTitleRender}
        fixSiderbar
        splitMenus
      >
        {children}
      </Layout>
    </Wrapper>
  );
};
